module.exports = __webpack_public_path__ + "static/img/shopee.b0ea6a37.svg";